import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import GPTGallery from "@/pages/GPTGallery";
import Chat from "@/pages/Chat";
import Admin from "@/pages/Admin";
import Bootcamps from "@/pages/Bootcamps";
import Resources from "@/pages/Resources";
import KnowledgeBase from "@/pages/KnowledgeBase";
import MentorshipOnboarding from "@/pages/MentorshipOnboarding";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <Toaster position="top-center" richColors closeButton />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <GPTGallery />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/chat/:gptId"
                element={
                  <ProtectedRoute>
                    <Chat />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/knowledge-base"
                element={
                  <ProtectedRoute>
                    <KnowledgeBase />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/resources"
                element={
                  <ProtectedRoute>
                    <Resources />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/bootcamps"
                element={
                  <ProtectedRoute>
                    <Bootcamps />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mentorship/onboarding"
                element={
                  <ProtectedRoute>
                    <MentorshipOnboarding />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
